module.exports = __webpack_public_path__ + "img/mobile-banner3-en.13b0a5b1.jpg";